import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import '../../assests/scss/header.scss';
import {getTranslation, getSessionStorage} from '../../actions/corporateSignupAction';

const Header = (props) => {
      useEffect(() => {
        props.getTranslation();
        props.getSessionStorage();
    }, []);

    return <>       
            <div className={props.pageStep === 3 ? "main-wrapper-success" : 'main-wrapper'}>
               {props.children}
            </div>
       
    </>
}


const mapStateFromReducer = (state) => ({
    labels : state.corporateSignupReducer.labels || {}
  })
const mapDispatchToActions = (dispatch) => ({
    getTranslation: (requestBody) => dispatch(getTranslation(requestBody)),
    getSessionStorage: (requestBody) => dispatch(getSessionStorage(requestBody))
})

export default connect(
    mapStateFromReducer,
    mapDispatchToActions
)(Header);